const formatCampo = (value) => {
  const modalidades = {
    administracion: "Administración",
    presencial: "Presencial",
    hibrida: "Híbrida",
  };

  if (modalidades[value]) return modalidades[value];

  // fallback automático
  return value
    ?.replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());
};

const Campo = ({ value }) => {
  if (!value) return null;

  return (
    <p>
     {formatCampo(value)}
    </p>
  );
};

export default Campo;